import React, { useEffect, useState } from 'react';
import '../../styles.css';
import VerificationRow from './VerificationRow.js';
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';
import { firestore } from '../../Firebase';
import LetterCardGridSuper from '../studentProgress/LetterCardGridSuper.js';

function VerificationList() {
    const [names, setNames] = useState([])
    const [usernames, setUsernames] = useState([])
    const [emails, setEmails] = useState([])
    const [roles, setRoles] = useState([])
    const [classCodes, setClassCodes] = useState([])
    const [status, setStatus] = useState([])
    var users = [];

    useEffect(() => {
        const unsub = firestore.collection('accounts').where("role", '!=', "admin")
            .onSnapshot(snap => {
                setUsernames(snap.docs.map((doc) => doc.data().username))
                setNames(snap.docs.map((doc) => doc.data().name))
                setEmails(snap.docs.map((doc) => doc.data().email))
                setRoles(snap.docs.map((doc) => doc.data().role))
                setClassCodes(snap.docs.map((doc) => doc.data().classcode))
                setStatus(snap.docs.map((doc) => doc.data().verified))
            });
        return () => {
            unsub();
        }
    }, [firestore])

    for (let i = 0; i < names.length; i++) {
        users[i] = <VerificationRow userFullName={names[i]} username={usernames[i]} email={emails[i]} status={status[i]} designation={roles[i]} classCode={classCodes[i]} />
    }

    var individualButtons = []

    for (let i = 0; i < names.length; i++) {
        if (status[i] === "true") {
            individualButtons[i] = <LetterCardGridSuper name={names[i]} username={usernames[i]} />
        }
    }

    return (
        <div className='column'>
            <b className='tableHeading'>Verification List</b>
            <Table style={{ width: "fit-content", marginBottom: '40px' }}>
                <TableHead>
                    <TableRow>
                        <TableCell align="left"><b>Name</b></TableCell>
                        <TableCell className="hide" align="left"><b>Username</b></TableCell>
                        <TableCell className="hide" align="left"><b>Email</b></TableCell>
                        <TableCell align="center"><b>Designation</b></TableCell>
                        <TableCell className="hide" align="center"><b>Class Code</b></TableCell>
                        <TableCell align="center"><b>Verified</b></TableCell>
                        <TableCell className="hide" align="center"><b>V / D</b></TableCell>
                    </TableRow>
                </TableHead>
                <TableBody>
                    {users}
                </TableBody>
            </Table>
            {individualButtons}
        </div>
    );
}

export default VerificationList;
